(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["native-quantity-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lazenne-quantity-summary')) {
    customElements.define('lazenne-quantity-summary', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        if (this.querySelector('[data-selection-price]')) {
          this.moneyFormatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' });
        }
        for (const type of ['input', 'change']) {
          document.addEventListener(type, event => {
            if (event.target === this.quantityInput) this.updateSummary();
          }, { signal });
        }
        for (const type of ['variant:change', 'product:rerender', 'reset']) {
          document.addEventListener(type, event => {
            if (event.target.id === this.dataset.formId) this.scheduleUpdate();
          }, { signal, capture: true });
        }
        this.scheduleUpdate();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        cancelAnimationFrame(this.updateFrame);
      }
      get quantityInput() {
        const input = document.getElementById(this.dataset.formId)?.elements?.namedItem('quantity');
        return input instanceof HTMLInputElement ? input : null;
      }
      scheduleUpdate() {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.updateSummary();
        });
      }
      updateSummary() {
        const input = this.quantityInput;
        const output = this.querySelector('[role="status"]');
        if (!input || !output) return;
        const quantity = Number(input.value);
        const count = quantity * Number(this.dataset.unitsPerQuantity);
        const valid = Number.isSafeInteger(quantity) && quantity > 0 && Number.isSafeInteger(count) && input.validity.valid;
        output.hidden = !valid;
        const price = this.querySelector('[data-selection-price]');
        if (price) price.hidden = !valid;
        if (!valid) return;
        const template = count === 1 ? this.dataset.templateOne : this.dataset.templateOther;
        const text = template.replaceAll('__COUNT__', String(count));
        if (output.textContent !== text) output.textContent = text;
        if (price) {
          const total = Number(this.dataset.unitPrice) * quantity;
          const saving = Math.max(0, Number(this.dataset.unitSaving)) * quantity;
          const totalOutput = this.querySelector('[data-selection-total]');
          const totalText = this.moneyFormatter.format(total / 100);
          if (totalOutput.textContent !== totalText) totalOutput.textContent = totalText;
          const savingOutput = this.querySelector('[data-selection-saving]');
          savingOutput.hidden = saving <= 0;
          if (saving > 0) {
            const savingText = this.dataset.savingTemplate.replaceAll('__AMOUNT__', this.moneyFormatter.format(saving / 100));
            if (savingOutput.textContent !== savingText) savingOutput.textContent = savingText;
          }
          const pairAlternative = this.querySelector('[data-pair-alternative]');
          if (pairAlternative) pairAlternative.hidden = quantity < 2;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["native-winecush-choices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lazenne-quantity-offers')) {
    customElements.define('lazenne-quantity-offers', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.moneyFormatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' });
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-quantity]');
          const input = this.quantityInput;
          if (!button || !this.contains(button) || button.disabled || !input) return;
          input.value = button.dataset.quantity;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          this.updateChoices();
        }, { signal });
        for (const type of ['input', 'change']) {
          document.addEventListener(type, event => {
            if (event.target === this.quantityInput) this.updateChoices();
          }, { signal });
        }
        for (const type of ['variant:change', 'product:rerender', 'reset']) {
          document.addEventListener(type, event => {
            if (event.target.id === this.dataset.formId) this.scheduleUpdate();
          }, { signal, capture: true });
        }
        this.scheduleUpdate();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        cancelAnimationFrame(this.updateFrame);
      }
      get quantityInput() {
        const input = document.getElementById(this.dataset.formId)?.elements?.namedItem('quantity');
        return input instanceof HTMLInputElement ? input : null;
      }
      scheduleUpdate() {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => {
          if (this.isConnected) {
            this.hidden = !this.quantityInput;
            this.updateChoices();
          }
        });
      }
      updateChoices() {
        const input = this.quantityInput;
        if (!input) return;
        const min = Number(input.min || 1), max = Number(input.max || Infinity), step = Number(input.step || 1);
        const selectedQuantity = Number(input.value);
        for (const button of this.querySelectorAll('button[data-quantity]')) {
          const quantity = Number(button.dataset.quantity);
          button.disabled = quantity < min || quantity > max || (quantity - min) % step !== 0;
          button.setAttribute('aria-pressed', String(quantity === selectedQuantity));
        }
        const status = this.querySelector('[data-selection-status]');
        const valid = Number.isSafeInteger(selectedQuantity) && selectedQuantity > 0 && input.validity.valid;
        status.hidden = !valid;
        if (!valid) return;
        const verified = this.dataset.offerVerified === 'true';
        const unitPrice = Number(this.dataset.unitPrice);
        const unitDiscount = selectedQuantity >= 2 && verified ? Number(this.dataset.unitDiscount) : 0;
        const saving = unitDiscount * selectedQuantity;
        const subtotal = (unitPrice - unitDiscount) * selectedQuantity;
        const contentsTemplate = selectedQuantity === 1 ? this.dataset.selectionOne : this.dataset.selectionMany;
        const contents = contentsTemplate.replaceAll('__COUNT__', String(selectedQuantity)).replaceAll('__SLEEVES__', String(selectedQuantity * 6));
        this.setText('[data-selection-contents]', contents);
        this.setText('[data-selection-total]', this.moneyFormatter.format(subtotal / 100));
        const savingElement = this.querySelector('[data-selection-saving]');
        savingElement.hidden = saving === 0;
        if (saving > 0) this.setText('[data-selection-saving]', this.dataset.selectionSaving.replaceAll('__AMOUNT__', this.moneyFormatter.format(saving / 100)));
        this.querySelector('[data-selection-before]').hidden = verified || selectedQuantity < 2;
      }
      setText(selector, value) {
        const element = this.querySelector(selector);
        if (element.textContent !== value) element.textContent = value;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    let refreshTimer;
    let labelFrame;
    const started = new WeakSet();
    const renderedSelector = '.yotpo-sr-star-full, .yotpo-sr-star-half';
    const schedule = () => {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(() => {
        const pending = [...document.querySelectorAll('.product-card__yotpo-rating')].filter(card => !started.has(card));
        if (!pending.length) return;
        pending.forEach(card => started.add(card));
        const deadline = Date.now() + 20000;
        const initialize = () => {
          if (!pending.some(card => card.isConnected)) return;
          const container = window.yotpoWidgetsContainer;
          if (typeof container?.initWidgets !== 'function') {
            if (Date.now() < deadline) window.setTimeout(initialize, 250);
            return;
          }
          container.initWidgets();
          window.setTimeout(() => {
            let replaced = false;
            pending.forEach(card => {
              if (!card.isConnected || card.querySelector(renderedSelector)) return;
              const previous = card.querySelector('.yotpo-widget-instance');
              if (!previous) return;
              const fresh = document.createElement('div');
              fresh.className = 'yotpo-widget-instance';
              ['data-yotpo-instance-id', 'data-yotpo-product-id', 'data-yotpo-section-id'].forEach(name => {
                const value = previous.getAttribute(name);
                if (value !== null) fresh.setAttribute(name, value);
              });
              card.dataset.reviewRecovery = 'attempted';
              previous.replaceWith(fresh);
              replaced = true;
            });
            if (replaced) container.initWidgets();
          }, 6500);
        };
        initialize();
      }, 100);
    };
    const observeCards = () => {
      const main = document.querySelector('main') || document.getElementById('main');
      if (!main) return;
      new MutationObserver(mutations => {
        window.cancelAnimationFrame(labelFrame);
        labelFrame = window.requestAnimationFrame(() => {
          main.querySelectorAll('.product-card__yotpo-rating[data-review-singular]').forEach(card => {
            const label = card.querySelector('.yotpo-sr-bottom-line-text');
            const desired = card.dataset.reviewSingular;
            if (label && /^1\s+\D/.test(label.textContent.trim()) && label.textContent.trim() !== desired) {
              label.textContent = desired;
            }
          });
        });
        const addedCards = mutations.some(({ addedNodes }) => [...addedNodes].some(node =>
          node instanceof Element && (node.matches('.product-card__yotpo-rating') || node.querySelector('.product-card__yotpo-rating'))
        ));
        if (addedCards) schedule();
      }).observe(main, { childList: true, subtree: true });
      schedule();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCards, { once: true });
    } else {
      observeCards();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
